import { Box, IconButton, Stack, Typography } from "@mui/material"
import { useLocation, useNavigate, useParams } from "react-router"
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos'
import { RoutePaths } from "../routes"
import { useSingleNews } from "../hooks/useNews"
import { BlocksRenderer } from '@strapi/blocks-react-renderer'

const CurrentNewsPage = () => {
  const { id } = useParams()
  const { newsItem, loading, error } = useSingleNews(id)
  const navigate = useNavigate()
  const location = useLocation()

  const formatDate = (date) => {
    return new Date(date).toLocaleDateString('ru-RU', {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    })
  }

  if (loading) return <Typography variant="h3">Загрузка новости...</Typography>
  if (error) return <Typography color="error">{error}</Typography>
  if (!newsItem) return <Typography variant="h3">Новость не найдена</Typography>

  return (
    <Box sx={{ maxWidth: 800, margin: '0 auto', padding: 3 }}>
      <IconButton 
        disableRipple 
        onClick={() => navigate(RoutePaths.NEWS, { state: location.state })} 
        sx={{ color: 'blue.400', mb: 3 }}
      >
        <ArrowBackIosIcon />
        <Typography variant="body1" sx={{ ml: 1 }}>Назад к новостям</Typography>
      </IconButton>

      <Typography variant="h1" gutterBottom>{newsItem.title}</Typography>
      
      <Typography variant="subtitle1" color="text.secondary" gutterBottom>
        {formatDate(newsItem.date)}
      </Typography>

      {newsItem.largeImg && (
          <img src={newsItem.largeImg} alt={newsItem.title} style={{maxWidth: '100%',  height: 'auto', float: 'left', marginBight: '24px' , marginBottom: '24px'}}/>
      )}

      <Box sx={{ 
        '& p': { mb: 2, lineHeight: 1.6 },
        '& h2': { mt: 4, mb: 2 },
        '& ul': { pl: 3 },
        '& img': { maxWidth: '100%', height: 'auto' }
      }}>
        {newsItem.body ? (
          <BlocksRenderer content={newsItem.body} />
        ) : (
          <Typography>Текст недоступен</Typography>
        )}
      </Box>
    </Box>
  )
}

export default CurrentNewsPage